export const SET_TERMINAL = 'SET_TERMINAL'
export const SET_ACTIVECOMPONENT = 'SET_ACTIVECOMPONENT'
export const SET_COMPONENTSDATA = 'SET_COMPONENTSDATA'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js